module.exports = __webpack_public_path__ + "media/images/reset-password-2471a875d26a0fabf031210fe6fcd1d4.png";